/* RAVIN LANGUAGE-AWARE TYPE v2
   Auto-detect actual script of storefront text. English remains Anton/Inter even
   when Shopify locale is Arabic. Arabic creative fields get the Arabic families.
   No layout, motion, cart, search, or product pricing logic is modified.
*/
(()=>{'use strict';
 const TEXT_SELECTOR='h1,h2,h3,h4,h5,h6,button,label,summary,figcaption,small,strong,em,span,p,a,.rod-shadow,.rpa-pdp-product-heading,.rpa-pdp-utility-heading,.ravin-pdp-arc-title,.ravin-deck__card-title,.ravin-sideways__card-title,.ravin-arc__card-title,.rvx-drawer-title,.rvx-directory-head,.rfo-display,.rlo__title,[data-rfl-head],[data-rv-style]';
 const arabic=/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
 const latin=/[A-Za-z]/;
 function mark(el){
  if(!el||el.nodeType!==1||el.closest('script,style,noscript,svg,[data-rv-script-ignore]'))return;
  if(el.hasAttribute('lang')&&!el.hasAttribute('data-rv-assigned-lang'))return;
  const content=el.textContent||'';
  if(!content||content.length>350)return;
  const hasArabic=arabic.test(content),hasLatin=latin.test(content);
  if(!hasArabic&&!hasLatin)return;
  const type=hasArabic&&hasLatin?'mixed':hasArabic?'arabic':'latin';
  if(el.dataset.rvScript===type)return;
  el.dataset.rvScript=type;
  if(type!=='mixed'){
   el.lang=type==='arabic'?'ar':'en';
   el.dataset.rvAssignedLang='1';
  }else if(el.hasAttribute('data-rv-assigned-lang')){
   el.removeAttribute('lang');delete el.dataset.rvAssignedLang;
  }
 }
 function scan(root){
  if(!root||root.nodeType!==1)return;
  if(root.matches(TEXT_SELECTOR))mark(root);
  root.querySelectorAll(TEXT_SELECTOR).forEach(mark);
 }
 let queue=new Set();let pending=false;
 function flush(){pending=false;const selected=[...queue];queue.clear();for(const el of selected)scan(el);}
 function schedule(el){if(!el||el.nodeType!==1)return;queue.add(el);if(!pending){pending=true;requestAnimationFrame(flush);}}
 function init(){scan(document.body); const observer=new MutationObserver(records=>{
   for(const record of records){if(record.type==='characterData'){schedule(record.target.parentElement);continue;}
    for(const node of record.addedNodes){if(node.nodeType===1)schedule(node);else if(node.nodeType===3)schedule(record.target);}
   }
  }); observer.observe(document.body,{subtree:true,childList:true,characterData:true});
  document.addEventListener('shopify:section:load',event=>schedule(event.target));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
